module.exports = __webpack_public_path__ + "img/SL7_4579-Bearbeitet.810eb431.jpg";